import type { ReactNode } from "react";
import { Link as RouterLink } from "react-router";
import CDS from "design-system";

interface CardFooterLinkProps {
  to: string;
  children: ReactNode;
  showBorder?: boolean;
}

export default function CardFooterLink({ to, children, showBorder = true }: CardFooterLinkProps) {
  return (
    <CDS.Text12
      as={RouterLink}
      {...{ to }}
      display="block"
      color="brand.500"
      fontWeight="500"
      px={6}
      py={3}
      borderTopWidth={showBorder ? "1px" : 0}
      borderColor="gray.100"
      _hover={{ textDecoration: "underline", bg: "gray.50" }}
    >
      {children}
    </CDS.Text12>
  );
}
